/**
 * Video modal — opens an overlay with embedded <video> when user clicks
 * [data-video-modal-open]. Sets src lazily on first open so the video
 * doesn't preload on every page view.
 */
export default function initVideoModal() {
  const modal = document.getElementById('videoModal');
  if (!modal) return;

  const openBtns  = document.querySelectorAll('[data-video-modal-open]');
  const closeBtn  = modal.querySelector('[data-video-modal-close]');
  const video     = modal.querySelector('.video-modal__player');
  const videoSrc  = video ? video.getAttribute('data-video-src') : '';

  if (!openBtns.length || !closeBtn || !video || !videoSrc) return;

  const open = () => {
    if (!video.src) video.src = videoSrc;       // lazy-load on first open
    modal.hidden = false;
    document.body.classList.add('video-modal-open');
    requestAnimationFrame(() => {
      video.play().catch(() => { /* autoplay may be blocked — ignore */ });
    });
  };

  const close = () => {
    video.pause();
    modal.hidden = true;
    document.body.classList.remove('video-modal-open');
  };

  openBtns.forEach((b) => b.addEventListener('click', open));
  closeBtn.addEventListener('click', close);

  // Click outside video area closes modal.
  modal.addEventListener('click', (e) => {
    if (e.target === modal) close();
  });

  // Esc key closes modal.
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hidden) close();
  });
}
